/**
 * Ticket Form Wrapper
 * 
 * This component wraps the ticket creation form with the FieldStructureProvider
 * to provide field structure context to all child components.
 */

import React from 'react';
import { FieldStructureProvider } from '../../../../contexts/FieldStructureContext';
import NewTicket from './index';

const TicketFormWrapper = (props) => {
  return (
    <FieldStructureProvider>
      <NewTicket {...props} />
    </FieldStructureProvider>
  );
};

export default TicketFormWrapper;
